import { render, staticRenderFns } from "./UserCreationForm.vue?vue&type=template&id=5d8f1661&"
import script from "./UserCreationForm.vue?vue&type=script&lang=js&"
export * from "./UserCreationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports